import { RetireView } from "./retire-view";
import { useRetire } from "./use-retire";

export const Retire = () => {
  const logic = useRetire();
  return <RetireView {...logic} />;
};
